// GNB(Sidebar) 노출 항목과 각 화면(AdminLayout)의 접근 권한 검사가 같은 기준을 쓰도록
// 한 곳에 모아둔다. menuUrl 은 TB_MENU.menu_url 값(백엔드 메뉴관리 화면 기준,
// db/seed/seed_data.sql 참고)과 정확히 일치해야 한다 - 프론트 라우트 경로(to)와 이름
// 규칙이 달라서(예: /admin/product vs /products) 단순 문자열 비교로는 매칭이 안 되므로
// 항목마다 명시적으로 짝지어 둔다.
//
// [2단 트리 재편] 예전엔 flat 배열(NAV_ITEMS)만 있었으나, 메뉴가 20개를 넘어가며 성격별로
// 묶어 2단(대분류 그룹 > 메뉴) 트리로 재편했다. 실제 렌더는 NAV_GROUPS 기준(Sidebar),
// 권한 필터는 여전히 leaf 의 menuUrl 단위로 동작한다(권한 모델 변경 없음).
// 대시보드는 로그인 직후 홈이라 그룹에 넣지 않고 최상단 단독 항목으로 둔다.
import {
  DashboardIcon, MemberIcon, AccountIcon, MenuIcon, CodeIcon, NoticeIcon, HistoryIcon, ProductIcon, CategoryIcon, OrderIcon,
  StoreIcon, TableOrderIcon, TableCallIcon, ReservationIcon, ReviewIcon, BannerIcon, OrderDiscountIcon,
} from '../components/common/Icons';

// 로그인한 관리자라면 역할과 무관하게 항상 접근 가능한 화면 (대시보드). 메뉴관리에서 실수로
// 이 항목의 역할별 권한을 모두 회수해도 로그인 후 갈 곳이 없어 리다이렉트 루프에 빠지는 것을
// 막기 위해 AdminLayout 이 이 값만은 별도로 항상 허용한다.
export const DASHBOARD_MENU_URL = '/admin/dashboard';

// 최상단 단독 항목 (그룹 없음)
export const DASHBOARD_ITEM = { to: '/dashboard', label: '대시보드', icon: DashboardIcon, menuUrl: DASHBOARD_MENU_URL };

// 대분류 그룹(2단 트리). 각 그룹은 성격이 같은 메뉴들을 묶는다.
export const NAV_GROUPS = [
  {
    label: '상품·주문', icon: ProductIcon, items: [
      { to: '/products', label: '상품관리', icon: ProductIcon, menuUrl: '/admin/product' },
      { to: '/categories', label: '상품분류관리', icon: CategoryIcon, menuUrl: '/admin/category' },
      { to: '/orders', label: '상품주문관리', icon: OrderIcon, menuUrl: '/admin/order' },
      { to: '/order-discounts', label: '주문할인관리', icon: OrderDiscountIcon, menuUrl: '/admin/order-discount' },
    ],
  },
  {
    label: '매장·브랜드', icon: StoreIcon, items: [
      { to: '/stores', label: '매장관리', icon: StoreIcon, menuUrl: '/admin/store' },
      { to: '/brands', label: '브랜드관리', icon: StoreIcon, menuUrl: '/admin/brand' },
    ],
  },
  {
    label: '매장운영', icon: TableOrderIcon, items: [
      { to: '/table-orders', label: '테이블오더관리', icon: TableOrderIcon, menuUrl: '/admin/table-order' },
      { to: '/table-calls', label: '직원호출관리', icon: TableCallIcon, menuUrl: '/admin/table-call' },
      { to: '/reservations', label: '예약관리', icon: ReservationIcon, menuUrl: '/admin/reservation' },
    ],
  },
  {
    label: '매출·통계', icon: OrderIcon, items: [
      { to: '/pos-sales', label: 'POS매출', icon: OrderIcon, menuUrl: '/admin/pos-sales' },
      { to: '/sales-stats', label: '기간별매출통계', icon: OrderIcon, menuUrl: '/admin/sales-stats' },
    ],
  },
  {
    label: '고객', icon: MemberIcon, items: [
      { to: '/members', label: '회원관리', icon: MemberIcon, menuUrl: '/admin/member' },
      { to: '/reviews', label: '리뷰관리', icon: ReviewIcon, menuUrl: '/admin/review' },
    ],
  },
  {
    label: '콘텐츠', icon: BannerIcon, items: [
      { to: '/banners', label: '배너관리', icon: BannerIcon, menuUrl: '/admin/banner' },
      { to: '/notices', label: '공지사항관리', icon: NoticeIcon, menuUrl: '/admin/notice' },
    ],
  },
  {
    label: '시스템', icon: AccountIcon, items: [
      { to: '/accounts', label: '관리자계정관리', icon: AccountIcon, menuUrl: '/admin/account' },
      { to: '/menus', label: '메뉴관리', icon: MenuIcon, menuUrl: '/admin/menu' },
      { to: '/codes', label: '공통코드관리', icon: CodeIcon, menuUrl: '/admin/code' },
      { to: '/push-message', label: '실시간 알림', icon: NoticeIcon, menuUrl: '/admin/push-message' },
    ],
  },
  {
    label: '이력', icon: HistoryIcon, items: [
      { to: '/history/login', label: '로그인이력관리', icon: HistoryIcon, menuUrl: '/admin/history/login' },
      { to: '/history/use', label: '사용이력관리', icon: HistoryIcon, menuUrl: '/admin/history/use' },
    ],
  },
];

// 하위호환용 flat 배열(대시보드 + 모든 그룹의 leaf). AuthContext 등 기존에 flat 목록을
// 참조하던 코드가 그대로 동작하도록 유지한다.
export const NAV_ITEMS = [DASHBOARD_ITEM, ...NAV_GROUPS.flatMap((g) => g.items)];
